import { createContext } from "react";

const TabsWrapperContext = createContext(null as any);

export default TabsWrapperContext;
